import { ReactNode } from 'react';

import { usePathGuard } from '@web/app/shared';

import { CheckingPage } from './components/CheckingPage';
import { ErrorPage } from './components/ErrorPage';

export const AuthPathRoute = ({ children }: { children: ReactNode }) => {
    const { isChecking, error } = usePathGuard();

    if (isChecking) {
        return <CheckingPage />;
    }

    if (error) {
        return <ErrorPage error={error} />;
    }

    return <>{children}</>;
};
